export const rateUnits: Array<IOption> = [
  {value: 'percent', label: 'درصد'},
  {value: 'price', label: 'قیمت'},
];
